import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './public/css/public.css'
import './public/css/element-variables.scss'
// import "babel-polyfill";

import Element from 'element-ui'
Vue.use(Element)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')